import React, { FunctionComponent } from 'react';
import { cn } from '@companion-professional/webutils';

export const sizes = {
  small: 'h-5 w-5',
  medium: 'h-12 w-12',
  large: 'h-24 w-24'
};

interface LoaderSpinnerProps {
  // size of the spinner.  Defaults to medium.
  size?: keyof typeof sizes;

  // tone sets the color.  "primary" (default) is the theme primary color; "current" follows the surrounding text color,
  // e.g. inside a Button.
  tone?: 'primary' | 'current';
}

// LoaderSpinner is a component that renders an animated spinner.  This can be used to indicate that a page is loading.
// It uses the theme primary color (Shepherd Blue) on a faint track of the same color.
// Comes in three sizes: small, medium, and large.  Defaults to medium.
export const LoaderSpinner: FunctionComponent<LoaderSpinnerProps> = ({ size = 'medium', tone = 'primary' }) => {
  return (
    <div className={cn('flex justify-center', tone === 'primary' ? 'text-primary' : 'text-current')}>
      <svg className={`${sizes[size]} animate-spin`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
  );
};
